export const generalSettingList = [
  {
    isElectron: true,
    title: "Import books as link",
    desc: "The imported books will not be copied to library, only linked to the original book path",
    propName: "isImportPath",
  },

  {
    isElectron: false,
    title: "Disable trash bin",
    desc: "When deleting books, they will be deleted permanently instead of sending to trash bin",
    propName: "isDisableTrashBin",
  },
  {
    isElectron: false,
    title: "Hide books already added to the shelf",
    desc: "Hide books which have been added to the shelf, so they won't show up in home page",
    propName: "isHideShelfBook",
  },
  {
    isElectron: false,
    title: "Delete book from shelf also deleting book itself",
    desc: "When deleting book from shelf, the book will be deleted as well",
    propName: "isDeleteShelfBook",
  },
  {
    isElectron: true,
    title: "Disable screen blanking",
    desc: "When Koodo is running, your computer won't enter sleep mode",
    propName: "isPreventSleep",
  },
  {
    isElectron: true,
    title: "Windows always on top",
    propName: "isAlwaysOnTop",
  },
  {
    isElectron: true,
    title: "Auto maximize main window",
    desc: "Main window will be maximized to fit the screen when launching",
    propName: "isAutoMaximizeWin",
  },
  {
    isElectron: true,
    title: "Automatically launch on system startup",
    propName: "isAutoLaunch",
  },
  {
    isElectron: true,
    title: "Open book without adding it to library",
    desc: "When opening books in the file manager with Koodo, the opened books won't be added to the library",
    propName: "isPreventAdd",
  },

  {
    isElectron: false,
    title: "Auto precache books after import",
    desc: "Pre-cache books after import to increase opening speed, Koodo will generate a precache version of the original book and save it into your library",
    propName: "isPrecacheBook",
  },
  {
    isElectron: false,
    title: "Export books with original name",
    propName: "isExportOriginalName",
  },
  {
    isElectron: false,
    title: "Disable AI features",
    propName: "isDisableAI",
  },
  {
    isElectron: false,
    title: "Use file name as book title",
    propName: "isUseOriginalName",
  },
  {
    isElectron: true,
    title: "Disable update notification",
    propName: "isDisableUpdate",
  },
  {
    isElectron: true,
    title: "Delete original file when permanently deleting books",
    propName: "isDeleteOriginal",
  },
  {
    isElectron: true,
    title: "Open url with built-in browser",
    propName: "isUseBuiltIn",
  },
];
export const appearanceSettingList = [
  {
    isElectron: false,
    title: "Don't use first page as PDF cover",
    desc: "",
    propName: "isDisablePDFCover",
  },
  {
    isElectron: false,
    title: "Don't crop book cover",
    propName: "isDisableCrop",
  },
];
export const syncSettingList = [
  {
    isElectron: false,
    title: "Disable automatic sync",
    desc: "By default, Koodo Reader will automatically synchronize your data when you open the app and exit reading",
    propName: "isDisableAutoSync",
  },
  {
    isElectron: false,
    title: "Auto download cloud books",
    desc: "To reduce storage usage, only the book metadata is downloaded by default, and the book files are not downloaded. After enabling this option, all book files will be downloaded during synchronization",
    propName: "autoOffline",
  },
  {
    isElectron: false,
    title: "Enable Koodo Sync",
    desc: "Enable this option to increase synchronization speed. Your reading progress, notes, highlights, bookmarks, and other reading-related data will be stored and synced via our cloud service, your books and covers will still be synced by your added data sources. Turning off this option will remove the above data from our cloud.",
    propName: "isEnableKoodoSync",
  },
  {
    isElectron: false,
    title: "Always keep local data when resolving sync conflicts",
    desc: "If you update a piece of data that has already been deleted in the cloud before synchronization, it will cause a conflict. In this case, we will keep the cloud data by default. If you turn this option on, we will keep the local data",
    propName: "isKeepLocal",
  },
];
export const readingSettingList = [
  {
    isElectron: false,
    title: "Turn on touch screen mode",
    desc: "Gesture and UI optimization for touch screen",
    propName: "isTouch",
  },
  {
    isElectron: false,
    title: "Prevent accidental trigger",
    desc: "Reader menu will not be triggered by hovering but clicking on the area",
    propName: "isPreventTrigger",
  },
  {
    isElectron: true,
    title: "Merge reader into Word",
    desc: "Get rid of window frame, make reader hide into Word or any text editor, and can't be detected. You need to set up the reader's position, size and style first.",
    propName: "isMergeWord",
  },
  {
    isElectron: true,
    title: "Open books in the main window",
    desc: "Book won't be opened in a separate window but directly opened in the main window",
    propName: "isOpenInMain",
  },
  {
    isElectron: false,
    title: "Disable automatically scroll to the bottom of the AI chat",
    desc: "",
    propName: "isManualScroll",
  },
  {
    isElectron: false,
    title: "Auto open last-read book",
    desc: "The book that you read from last time will be open automatically when launching",
    propName: "isOpenBook",
  },
  {
    isElectron: true,
    title: "Auto open book in maximized screen",
    desc: "Reader window will be maximized to fit the screen when opening a book",
    propName: "isAutoMaximize",
  },
  {
    isElectron: true,
    title: "Auto open book in full screen",
    desc: "Reader window will enter full screen when opening a book",
    propName: "isAutoFullscreen",
  },
  {
    isElectron: false,
    title: "No popup when selecting texts",
    desc: "Turn it on when you want Koodo to work with other third-party translation service, right clicking on the selected text will trigger popup again",
    propName: "isDisablePopup",
  },
  {
    isElectron: false,
    title: "Disable auto scroll to next or previous chapter",
    desc: "Disable auto scroll to next or previous chapter when reaching the end of the current chapter",
    propName: "isDisableAutoScroll",
  },
  {
    isElectron: false,
    title: "Overwrite the default link style in the book",
    propName: "isOverwriteLink",
  },
  {
    isElectron: false,
    title: "Overwrite the default text style in the book",
    propName: "isOverwriteText",
  },
  // {
  //   isElectron: false,
  //   title: "Lemmatize words when looking up in a dictionary",
  //   desc: "To reduce the different forms of a word to one single form, for example, reducing builds, building or built to build, reducing cats to cat, reducing fastest to fast",
  //   propName: "isLemmatizeWord",
  // },
];

export const langList = [
  { label: "简体中文", value: "zhCN" },
  { label: "繁體中文", value: "zhTW" },
  { label: "繁體中文-澳門", value: "zhMO" },
  { label: "English", value: "en" },
  { label: "Pусский", value: "ru" },
  { label: "Español", value: "es" },
  { label: "Français", value: "fr" },
  { label: "Português", value: "ptBR" },
  { label: "فارسی", value: "fa" },
  { label: "日本語", value: "ja" },
  { label: "Türkçe", value: "tr" },
  { label: "عربي", value: "ar" },
  { label: "čeština", value: "cs" },
  { label: "Deutsch", value: "de" },
  { label: "한국어", value: "ko" },
  { label: "Polski", value: "pl" },
  { label: "Română", value: "ro" },
  { label: "แบบไทย", value: "th" },
  { label: "italiano", value: "it" },
  { label: "Nederlands", value: "nl" },
  { label: "বাংলা", value: "bn" },
  { label: "български", value: "bg" },
  { label: "bahasa Indonesia", value: "id" },
  { label: "հայերեն", value: "hy" },
  { label: "བོད་སྐད།", value: "bo" },
  { label: "हिंदी", value: "hi" },
  { label: "Magyar", value: "hu" },
  { label: "Gaeilge", value: "ga" },
  { label: "Svenska", value: "sv" },
  { label: "Tagalog", value: "tl" },
  { label: "Slovenščina", value: "sl" },
  { label: "Srpski", value: "sr" },
  { label: "Українська", value: "uk" },
  { label: "தமிழ்", value: "ta" },
  { label: "ελληνικά", value: "el" },
  { label: "አማርኛ", value: "am" },
  { label: "Dansk", value: "da" },
  { label: "Suomi", value: "fi" },
  { label: "Interlingue", value: "ie" },
  { label: "Português(PT)", value: "pt" },
  { label: "Tiếng Việt", value: "vi" },
];

export const searchList = [
  { label: "Google", value: "google" },
  { label: "Baidu", value: "baidu" },
  { label: "Bing", value: "bing" },
  { label: "DuckDuckGo", value: "duckduckgo" },
  { label: "Yandex", value: "yandex" },
  { label: "Yahoo", value: "yahoo" },
  { label: "Naver", value: "naver" },
  { label: "Baidu Baike", value: "baike" },
  { label: "Wikipedia", value: "wiki" },
];
export const skinList = [
  {
    label: "Follow OS",
    value: "system",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 3a9 9 0 1 0 0 18A9 9 0 0 0 12 3zm0 2v14A7 7 0 0 1 12 5zm0 0"/></svg>`,
  },
  {
    label: "Light mode",
    value: "light",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-13a1 1 0 0 0 1-1V2a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1zm0 14a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1zm9-8h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm-17 1a1 1 0 0 0-1-1H2a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1zm13.66-6.07-.71.71a1 1 0 1 0 1.41 1.41l.71-.71a1 1 0 0 0-1.41-1.41zM6.34 17.66l-.71.71a1 1 0 1 0 1.41 1.41l.71-.71a1 1 0 0 0-1.41-1.41zm12.73.71-.71-.71a1 1 0 0 0-1.41 1.41l.71.71a1 1 0 0 0 1.41-1.41zM5.64 6.35l-.71-.71a1 1 0 0 0-1.41 1.41l.71.71A1 1 0 0 0 5.64 6.35z"/></svg>`,
  },
  {
    label: "Night mode",
    value: "night",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M21.64 13a1 1 0 0 0-1.05-.14 8.05 8.05 0 0 1-3.37.73 8.15 8.15 0 0 1-8.14-8.1 8.59 8.59 0 0 1 .25-2A1 1 0 0 0 8 2.36a10.14 10.14 0 1 0 13.75 13.75 1 1 0 0 0-.11-1.11z"/></svg>`,
  },
];

export const readerSettingList = [
  {
    title: "Sliding animation",
    propName: "isSliding",
    isPDF: true,
  },
  {
    title: "Render PDF from even page",
    propName: "isStartFromEven",
    isPDF: true,
  },
  {
    title: "Allow Javascript in the books",
    propName: "isAllowScript",
    isPDF: false,
  },
  {
    title: "Enable hyphenation",
    propName: "isHyphenation",
    isPDF: false,
  },
  {
    title: "Allow orphan and widow lines",
    propName: "isOrphanWidow",
    isPDF: false,
  },
  {
    title: "Fast reading mode (make the first half of the word bold)",
    propName: "isBionic",
    isPDF: false,
  },
  {
    title: "Text indentation",
    propName: "isIndent",
    isPDF: false,
  },
  {
    title: "Bold",
    propName: "isBold",
    isPDF: false,
  },
  {
    title: "Italic",
    propName: "isItalic",
    isPDF: false,
  },
  {
    title: "Underline",
    propName: "isUnderline",
    isPDF: false,
  },
  {
    title: "Shadow",
    propName: "isShadow",
    isPDF: false,
  },
  {
    title: "Invert color",
    propName: "isInvert",
    isPDF: true,
  },
  {
    title: "Show page border",
    propName: "isShowPageBorder",
    isPDF: true,
  },
  {
    title: "Hide footer",
    propName: "isHideFooter",
    isPDF: true,
  },

  {
    title: "Hide header",
    propName: "isHideHeader",
    isPDF: true,
  },
  {
    title: "Hide mimical background",
    propName: "isHideBackground",
    isPDF: true,
  },
  {
    title: "Hide navigation button",
    propName: "isHidePageButton",
    isPDF: true,
  },
  {
    title: "Hide menu button",
    propName: "isHideMenuButton",
    isPDF: true,
  },
  {
    title: "Hide audiobook button",
    propName: "isHideAudiobookButton",
    isPDF: true,
  },
  {
    title: "Hide AI button",
    propName: "isHideAIButton",
    isPDF: true,
  },
  {
    title: "Hide page scale button",
    propName: "isHideScaleButton",
    isPDF: true,
  },
  {
    title: "Hide pdf to text button",
    propName: "isHidePDFConvertButton",
    isPDF: true,
  },
];
export const officialTranList = {
  Automatic: "Automatic",
  English: "English",
  "Simplified Chinese": "Simplified Chinese",
  "Traditional Chinese": "Traditional Chinese",
  Russian: "Russian",
  Japanese: "Japanese",
  Korean: "Korean",
  Spanish: "Spanish",
  French: "French",
  Portuguese: "Portuguese",
  German: "German",
  Italian: "Italian",
  Thai: "Thai",
  Vietnamese: "Vietnamese",
  Indonesian: "Indonesian",
  Malay: "Malay",
  Arabic: "Arabic",
  Hindi: "Hindi",
  Hebrew: "Hebrew",
  Burmese: "Burmese",
  Tamil: "Tamil",
  Urdu: "Urdu",
  Bengali: "Bengali",
  Polish: "Polish",
  Dutch: "Dutch",
  Romanian: "Romanian",
  Turkish: "Turkish",
  Khmer: "Khmer",
  Lao: "Lao",
  Cantonese: "Cantonese",
  Czech: "Czech",
  Greek: "Greek",
  Swedish: "Swedish",
  Hungarian: "Hungarian",
  Danish: "Danish",
  Finnish: "Finnish",
  Ukrainian: "Ukrainian",
  Bulgarian: "Bulgarian",
  Serbian: "Serbian",
  Telugu: "Telugu",
  Afrikaans: "Afrikaans",
  Armenian: "Armenian",
  Assamese: "Assamese",
  Asturian: "Asturian",
  Basque: "Basque",
  Belarusian: "Belarusian",
  Bosnian: "Bosnian",
  Catalan: "Catalan",
  Cebuano: "Cebuano",
  Croatian: "Croatian",
  "Egyptian Arabic": "Egyptian Arabic",
  Estonian: "Estonian",
  Galician: "Galician",
  Georgian: "Georgian",
  Gujarati: "Gujarati",
  Icelandic: "Icelandic",
  Javanese: "Javanese",
  Kannada: "Kannada",
  Kazakh: "Kazakh",
  Latvian: "Latvian",
  Lithuanian: "Lithuanian",
  Luxembourgish: "Luxembourgish",
  Macedonian: "Macedonian",
  Maithili: "Maithili",
  Maltese: "Maltese",
  Marathi: "Marathi",
  "Mesopotamian Arabic": "Mesopotamian Arabic",
  "Moroccan Arabic": "Moroccan Arabic",
  "Najdi Arabic": "Najdi Arabic",
  Nepali: "Nepali",
  "North Azerbaijani": "North Azerbaijani",
  "North Levantine Arabic": "North Levantine Arabic",
  "Northern Uzbek": "Northern Uzbek",
  "Norwegian Bokmål": "Norwegian Bokmål",
  "Norwegian Nynorsk": "Norwegian Nynorsk",
  Occitan: "Occitan",
  Odia: "Odia",
  Pangasinan: "Pangasinan",
  Sicilian: "Sicilian",
  Sindhi: "Sindhi",
  Sinhala: "Sinhala",
  Slovak: "Slovak",
  Slovenian: "Slovenian",
  "South Levantine Arabic": "South Levantine Arabic",
  Swahili: "Swahili",
  Tagalog: "Tagalog",
  "Ta’izzi-Adeni Arabic": "Ta’izzi-Adeni Arabic",
  "Tosk Albanian": "Tosk Albanian",
  "Tunisian Arabic": "Tunisian Arabic",
  Venetian: "Venetian",
  Waray: "Waray",
  Welsh: "Welsh",
  "Western Persian": "Western Persian",
};
export const officialDictList = [
  { lang: "Automatic", code: "auto", nativeLang: "Automatic" },
  { lang: "English", code: "eng", nativeLang: "English" },
  { lang: "Simplified Chinese", code: "chs", nativeLang: "Simplified Chinese" },
  {
    lang: "Traditional Chinese",
    code: "cht",
    nativeLang: "Traditional Chinese",
  },
  { lang: "Japanese", code: "jpn", nativeLang: "Japanese" },
  { lang: "Korean", code: "kor", nativeLang: "Korean" },
  { lang: "French", code: "fra", nativeLang: "French" },
  { lang: "German", code: "deu", nativeLang: "German" },
  { lang: "Spanish", code: "spa", nativeLang: "Spanish" },
  { lang: "Italian", code: "ita", nativeLang: "Italian" },
  { lang: "Russian", code: "rus", nativeLang: "Russian" },
  { lang: "Portuguese", code: "por", nativeLang: "Portuguese" },
  {
    lang: "Classical Chinese",
    code: "ancient",
    nativeLang: "Classical Chinese",
  },
];
export const sampleQuestion = [
  {
    mode: "ask",
    emoji: "📖",
    question: "Summarize this chapter for me",
  },
  {
    mode: "ask",
    emoji: "📃",
    question: "What are the key points of this chapter",
  },
  {
    mode: "chat",
    emoji: "📰",
    question: "Recommend me some books from Colleen Hoover",
  },
  {
    mode: "chat",
    emoji: "🗞️",
    question: "Explain Stoicism and its principles to me",
  },
];
